import { type NativeStackOptionsArgs, Stack } from 'expo-router';
import type { ParamListBase } from 'expo-router/react-navigation';
import { StatusBar } from 'expo-status-bar';
import type { PropsWithChildren } from 'react';
import { Platform } from 'react-native';
import { withUnistyles } from 'react-native-unistyles';
import useHeaderBackButton from '@/hooks/useHeaderBackButton';

type ModalStackProps = PropsWithChildren<{
  changeStatusBarStyle?: boolean;
}>;

const UnistylesStack = withUnistyles(Stack, (theme) => ({
  screenOptions: ({
    navigation,
    route,
  }: NativeStackOptionsArgs<ParamListBase>) => ({
    contentStyle: {
      backgroundColor: theme.colors.surface,
    },
    headerStyle: {
      backgroundColor: theme.colors.surface,
    },
    headerShadowVisible: false,
    headerTintColor: theme.colors.typography,
    headerLeft:
      navigation.getState()?.routes[0]?.key === route.key
        ? () => <ModalCloseButton />
        : undefined,
  }),
}));

function ModalCloseButton() {
  const headerLeft = useHeaderBackButton(undefined, 'close-outline');
  return headerLeft();
}

export default function ModalStack({
  children,
  changeStatusBarStyle = true,
}: ModalStackProps) {
  return (
    <>
      <UnistylesStack>{children}</UnistylesStack>
      {Platform.OS === 'ios' && changeStatusBarStyle ? (
        <StatusBar style="light" animated />
      ) : null}
    </>
  );
}
